import { DataListColumnType } from '@/types/data-lists'
import useGetDetail, { UseGetDetailOptions } from '../core-hooks/useGetDetail'
import queryKeys from '../query-keys'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import buildService from '../create-service'

const service = buildService<DataListColumnType>({
  pathCategory: 'data_list_column_types',
})

export function useGetDataListColumnType({
  id,
  ...options
}: UseGetDetailOptions<DataListColumnType>) {
  const query = useGetDetail<DataListColumnType>({
    id,
    queryKey: queryKeys.dataListColumnTypes.detail({
      id,
      filters: options.filters,
    }),
    serviceFn: service.getDetail,
    ...options,
  })

  return {
    dataListColumnType: query.data,
    ...query,
  }
}

export function useGetDataListColumnTypes({
  filters,
  ...options
}: UseGetListOptions<DataListColumnType> = {}) {
  const query = useGetList<DataListColumnType>({
    filters,
    queryKey: queryKeys.dataListColumnTypes.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    dataListColumnTypes: query.allData,
    ...query,
  }
}
